import { Box, Stack, Typography, styled, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ButtonsPrimary } from '../../../components/ComponentApp/buttoms';
import HeaderLayout from '../../../components/Layout/Header/HeaderLayout';
import { TitleStepe } from '../../../components/Layout/InternalLayout/TitleStepe';
import StepperProgress from '../../../components/profile/StepperProgress';
import { alreadyDone } from './NewCompleteRegisterStepper';
import { EmailIcon } from '../../../components/Layout/Menu/components/icons/EmailIcon';
import { EmailIconSend } from '../../../components/Layout/Menu/components/icons/EmailIconSend';
import { ZoonIcon } from '../../../components/Layout/Menu/components/icons/ZoonIcon';
import capitalize from '../../../utils/capitalize';
const ParagraphDetail = styled(Typography)(({ theme }) => ({
  color: '182849',
  lineHeight: '1.5',
  fontWeight: '300',
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.button.fontSize,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.button.fontSize,
  },
}));

const StepperSection = ({ user, selectedContent, title, stepper, stepperLong, foreign }) => {
  const shouldHideStepper = stepper === 5 || (stepper === 3 && foreign);
  return (
    <>
      <Stack sx={{ marginTop: { xs: '10px', sm: '0px' } }}>
        <TitleStepe user={user} description={selectedContent} title={title} />
      </Stack>
      {!shouldHideStepper && (
        <Box
          sx={{
            margin: '0px',
            marginTop: '16px',
            width: { xs: '300px', md: '444px' },
          }}>
          <StepperProgress stepper={stepper} stepperLong={stepperLong} />
        </Box>
      )}
    </>
  );
};

export const NewCompleteRegistration = () => {
  const { user } = useSelector(state => state.auth);
  const theme = useTheme();
  const [start, setStart] = useState(true);
  const [back, setBack] = useState(true);

  const continueRegistration = () => {
    setStart(preState => !preState);
  };

  let step = 1;

  if (!user['custom:checkid-sign-doc']) {
    step = 4;
  }
  if (!user['custom:checkid-sign']) {
    step = 1;
  }

  const [stepper, setstepper] = useState(step ? step : 1);
  const [foreign, setForeign] = useState(false);
  const [steppercolor, setSteppercolor] = useState({
    comp1: alreadyDone(1, step),
    comp2: alreadyDone(2, step),
    comp3: alreadyDone(3, step),
    comp4: alreadyDone(4, step),
    comp5: alreadyDone(5, step),
  });
  const navigate = useNavigate();

  const handleClickHome = () => {
    navigate('/myprofilerisk');
  };

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'completeregistration',
        path: '/completeregistration',
        link: {
          url: '/completeregistration',
          title: 'onboarding completeregistration',
        },
      },
    });
  }, []);

  return (
    <>
      <HeaderLayout showLogoOnly />
      <Stack
        sx={{
          marginTop: { sm: '10px', xs: '10px' },
          width: '100%',
          flexDirection: 'column',
          padding: '20px',
        }}>
        <Stack
          sx={{
            width: { md: `${start ? '50%' : '50%'}` },
            mx: { xs: '20px', md: 'auto' },
            padding: 'clamp(1rem, -1.8571rem + 12.1905vw, 2rem);',
            bgcolor: theme.palette.white.main,
            justifyContent: 'center',
            alignItems: 'center',
          }}
          gap={1}>
          <Stack width={'80%'} margin={'30px 0px'} direction='row'>
            <Typography
              lineHeight={'clamp(1.05rem, -0.0833rem + 3.5556vw, 1.45rem)'}
              textAlign={'center'}
              component={'p'}
              sx={{
                fontSize: theme.typography.availableBalance.fontSize,
                color: theme.palette.primary.dark,
                fontWeight: theme.typography.smallText.fontWeight,
                [theme.breakpoints.down('sm')]: {
                  fontSize: theme.typography.button.fontSize,
                },
              }}>
              <Typography
                component={'span'}
                lineHeight={'clamp(1.05rem, -0.0833rem + 3.5556vw, 1.45rem)'}
                sx={{
                  fontSize: theme.typography.availableBalance.fontSize,
                  fontWeight: theme.typography.button.fontWeight,
                  color: theme.palette.secondary.text,
                  [theme.breakpoints.down('sm')]: {
                    fontSize: theme.typography.button.fontSize,
                  },
                }}>
                {capitalize(user.name)}
                {', '}
              </Typography>
              para continuar debemos verificar tu registro.
            </Typography>
          </Stack>
        </Stack>

        <Stack
          sx={{
            width: { md: '80%', sm: '80%' },
            mx: 'auto',
            boxSizing: 'border-box',
            flexDirection: 'column',
            padding: 'clamp(1rem, -1.8571rem + 12.1905vw, 2rem);',
            bgcolor: theme.palette.white.main,
            borderRadius: '1rem',
            boxShadow: '0px 0px 1rem 0px rgba(0, 0, 0, 0.1)',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          gap={1}>
          <Stack
            sx={{
              width: '100%',
              flexDirection: 'column',
              gap: 3,
              marginBottom: '1rem',
              padding: { md: '0px 10px', sm: '0 20px', xs: '0px 20px' },
            }}>
            <Typography variant='h6' color={theme.palette.secondary.text}>
              Ten en cuenta que
            </Typography>
            <Stack direction={'row'} gap={1} sx={{ alignItems: 'center' }}>
              <ZoonIcon />
              <ParagraphDetail>
                Estamos revisando la documentación que nos enviaste.
              </ParagraphDetail>
            </Stack>
            <Stack direction={'row'} gap={1} sx={{ alignItems: 'center' }}>
              <EmailIcon />
              <ParagraphDetail>
                Si aún no la has enviado, por favor revisa tu correo y envíala a:
              </ParagraphDetail>
            </Stack>
            <Stack direction={'row'} gap={1} sx={{ alignItems: 'center' }}>
              <EmailIconSend />
              <ParagraphDetail color={theme.palette.secondary.text}>
                contactosociedades@xcala.com
              </ParagraphDetail>
            </Stack>
            <Stack
              width={'100%'}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Stack width={{ sm: '100%', md: '100%', lg: '40%', xs: '100%' }}>
                <ButtonsPrimary
                  name='Entendido'
                  onClick={() => navigate('/myprofilerisk')}
                  fullWidth
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
